let pending = 0;
const listeners = new Set();

function notify() {
  const visible = pending > 0;
  listeners.forEach((fn) => fn(visible));
}

export function subscribeLoading(listener) {
  listeners.add(listener);
  listener(pending > 0);
  return () => listeners.delete(listener);
}

export function startLoading() {
  pending += 1;
  notify();
}

export function stopLoading() {
  pending = Math.max(0, pending - 1);
  notify();
}
